import { preventDoubleClick } from '../global/_doubleClick';
import { stripRestrictedCharFromInput } from '../global/_stripRestrictedCharFromInput';
import { inlineFormValidationOnBlur } from '../global/_inlineFormValidationOnBlur';
export const callCartShareFormView = (params, returnHTML) => {
	var myCallback = function () {
			stripRestrictedCharFromInput();
			inlineFormValidationOnBlur();
			preventDoubleClick();
		},
		url = '/webapp/wcs/stores/servlet/CartShareFormView',
		data = 'orderId=' + params.orderId + '&senderName=' + params.senderName + '&senderEmail=' + params.senderEmail;
	$.ajax({
		url: url,
		cache: false,
		type: 'POST',
		data: data,
		success: function (html) {
			returnHTML(html, myCallback);
			return false;
		},
	});
};
